import React, { useEffect } from 'react';

const ProfileConnectRedirect = () => {
    useEffect(() => {
        (async () => {
            localStorage.setItem('soFlow', 'apply');
            window.location.href = process.env.REACT_APP_SERVICE_ORCHESTRATOR_APPLY_URL;
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
        </>
    );
};

export default ProfileConnectRedirect;
